/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import { getRequest, postRequest, putRequest, exportRequest } from "../../helpers/Api";
import { types } from "../reducers/numbers";
import { userNotAuthorizedHandler } from "./authentication";

function* storeNumber({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  try {
    const res = yield call(payload.id ? putRequest : postRequest, {
      url: payload.id ? `/whitelist-number/${payload.id}` : "/whitelist-number",
      jsonContentType: true,
      authorized: true,
      body: JSON.stringify(payload.number),
    });

    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    if (res.status === 409) {
      const errorMessage =
        res.response && res.response.message
          ? res.response.message
          : res.message === "Conflict"
          ? "Phone number is used already"
          : res.message;
      payload.onFailure(errorMessage, {
        errors: [
          {
            key: res.response && res.response.field ? res.response.field : "number",
            error: errorMessage,
          },
        ],
      });
    } else if (res.status === 401) {
      yield call(userNotAuthorizedHandler);
      payload.onSuccess(null);
      return;
    } else if (res.status === 200) {
      payload.onSuccess(res);
      yield put({
        type: types.FETCH_NUMBER_REQUEST,
        payload: { page: 1, perPage: 20, onFailure: payload.onFailure },
      });
    } else {
      payload.onFailure(res.message);
    }
  } catch (err) {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    // @ts-ignore
    payload.onFailure(err.message || "Internal server error");
  }
}
/**
 * Fetch numbers when filters are changed
 */
function* fetchNumbersRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.numbers);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(getRequest, {
    url: `/whitelist-number?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }
  if (response.status === 200) {
    const numbers = response.result.map((comp) => {
      if (comp.status) {
        comp.status = "1";
      } else {
        comp.status = "0";
      }
      return comp;
    });
    yield put({ type: types.ADD_NUMBERS, payload: { numbers } });
    yield put({
      type: types.SET_NUMBER_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
  } else {
    yield put({ type: types.SET_LOADING, payload: { loading: false } });
    payload.onFailure(response.message || "Internal server error");
  }
}

function* exportNumberRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.punches);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");

  const response = yield call(exportRequest, {
    url: `/export/numbers?${params.toString()}`,
    authorized: true,
  });

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
  if (!response.status === 200) {
    payload.onFailure(response.message || "Internal server error");
  }
}
/**
 * Fetch numbers when filters are changed
 */
function* fetchLocationRequest({ payload }) {
  const response = yield call(getRequest, {
    url: `/locations`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_LOCATIONS, payload: { locations: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
}
/**
 * Fetch numbers when filters are changed
 */
function* fetchPayGroupsRequest({ payload }) {
  const response = yield call(getRequest, {
    url: `/pay-group`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_PAY_GROUPS, payload: { payGroups: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
}

/**
 * Fetch numbers when filters are changed
 */
function* fetchTimezonesRequest({ payload }) {
  const response = yield call(getRequest, {
    url: `/timezone`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    yield put({ type: types.ADD_TIMEZONE, payload: { timezones: response.result } });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
}
export default function* sagas() {
  yield takeEvery(types.ADD_NUMBER, storeNumber);
  yield takeEvery(types.UPDATE_NUMBER, storeNumber);
  yield takeEvery(types.FETCH_NUMBER_REQUEST, fetchNumbersRequest);
  yield takeEvery(types.FETCH_LOCATION_REQUEST, fetchLocationRequest);
  yield takeEvery(types.FETCH_PAY_GROUPS_REQUEST, fetchPayGroupsRequest);
  yield takeEvery(types.FETCH_TIMEZONE_REQUEST, fetchTimezonesRequest);
  yield takeEvery(types.EXPORT_NUMBER_REQUEST, exportNumberRequest);
}
